type PartnerStoreMap = Record<string, any>;

const pickFirstNonEmptyString = (...values: unknown[]): string | undefined => {
  for (const v of values) {
    if (typeof v === 'string') {
      const s = v.trim();
      if (s) return s;
    }
  }
  return undefined;
};

/**
 * Extract company/store name from a "store listing" object.
 * We intentionally do NOT default to "Big Rentals" or any other hardcoded value.
 */
export const getCompanyNameFromStoreInfo = (storeInfo: any): string | undefined => {
  if (!storeInfo) return undefined;
  return pickFirstNonEmptyString(
    // common nested shapes
    storeInfo.company?.name,
    storeInfo.partner?.name,
    storeInfo.companyName,
    storeInfo.company_name,
    storeInfo.storeName,
    storeInfo.store_name,
    storeInfo.name,
    storeInfo.partnerName,
    storeInfo.partner_name,
    storeInfo.title, // some backends store the brand name as the title for home pages
  );
};

/**
 * Find the best store listing for a pathname.
 * - Exact match first
 * - Then route-base matches (e.g. "/product/:id" -> "/product")
 * - Then fallback to home ("/") for company name
 */
export const getStoreInfoForPath = (partnerStore: PartnerStoreMap | undefined, pathname: string): any | undefined => {
  if (!partnerStore || !pathname) return undefined;

  // Exact match.
  if (partnerStore[pathname]) return partnerStore[pathname];

  // Common "base route" matches.
  if (pathname.startsWith('/product/')) {
    return partnerStore['/product'] || partnerStore['/product/'] || partnerStore['/'];
  }
  if (pathname.startsWith('/cart')) {
    return partnerStore['/cart'] || partnerStore['/cart/'] || partnerStore['/'];
  }

  // Fallback to home store listing if present.
  return partnerStore['/'];
};

export const buildPageTitle = (pageTitle: string | undefined, companyName: string | undefined): string | undefined => {
  const left = pickFirstNonEmptyString(pageTitle);
  const company = pickFirstNonEmptyString(companyName);

  if (left && company) return `${left} | ${company}`;
  if (left) return left;
  if (company) return company;
  return undefined;
};


